import { NavLink } from 'react-router-dom';

export interface NavigationProps {
  path: string;
  children: string | HTMLElement | JSX.Element;
  activeClassName?: string;
  className?: string;
}

export const Navigation = ({
  children,
  path,
  activeClassName = '',
  className = '',
}: NavigationProps) => {
  return (
    <NavLink
      className={({ isActive }) => `
        flex
        justify-center
        items-center
        ${className}
        ${
          isActive
            ? `text-black dark:text-grey-50 font-bold ${activeClassName}`
            : 'text-grey-50'
        }
      `}
      to={path}
    >
      {children}
    </NavLink>
  );
};
